import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base';
import Utils from '../js/utils';
export default (function (props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $update = _ref.$update,
      $tick = _ref.$tick;
  var page_name = 'nhaphang';
  var pn = "div[data-name=\"".concat(page_name, "\"]");

  var viewImage = function viewImage(e) {
    var images = $(e.target).data('images');

    if (images) {
      $f7.photoBrowser.create({
        photos: images.split(','),
        theme: 'dark',
        type: 'popup'
      }).open();
    } else {
      $f7.dialog.alert('Sản phẩm chưa có ảnh');
    }
  };

  var rows = [],
      grand_total = 0;
  $tick( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var ld, rs, master_rows, _loop, ma_ncc;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ld = $f7.dialog.preloader('Đang tải dữ liệu');
            _context.next = 3;
            return Base.call({
              method: '_findAll',
              table: 'hoadon_nhap',
              params: {
                fields: 'hoadon_nhap.*, product.images',
                join: 'LEFT JOIN product ON hoadon_nhap.ma_hang = product.code',
                where: 'ts=:ts',
                where_data: {
                  ts: props.ts
                },
                order: 'thanh_tien DESC'
              }
            });

          case 3:
            rs = _context.sent;
            ld.close();
            master_rows = {};
            rs.rows.map(function (row) {
              grand_total += parseInt(row.thanh_tien);

              if (master_rows[row.ma_ncc] === undefined) {
                master_rows[row.ma_ncc] = [row];
              } else {
                master_rows[row.ma_ncc].push(row);
              }
            });

            _loop = function _loop(ma_ncc) {
              var row = {};
              row.ten_ncc = master_rows[ma_ncc][0].ten_ncc;
              row.total_ncc = 0;
              row.detail_rows = [];
              master_rows[ma_ncc].forEach(function (drow) {
                row.detail_rows.push(drow);
                row.total_ncc += parseInt(drow.thanh_tien);
              });
              rows.push(row);
            };

            for (ma_ncc in master_rows) {
              _loop(ma_ncc);
            }

            $update();

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="${page_name}" style="position:fixed">
  <div class="navbar" style="position:fixed">
    <div class="navbar-bg"></div>
    <div class="navbar-inner">
      <div class="title sliding">Nhập hàng</div>
    </div>
  </div>
  <div class="page-content">  
    <div class="block-title">Tổng tiền: ${grand_total > 0 && Utils.num2Str(grand_total)}</div>

    ${rows && rows.map(row=>$h`
      <div class="card data-table margin-half">
        <div class="card-header">${row.ten_ncc}: ${Utils.num2Str(row.total_ncc)}</div>
        <table>
          <thead>
            <tr>
              <th>Sản phẩm</th>
              
            </tr>
          </thead>
          <tbody>
            ${row.detail_rows.map(drow=>$h`
              <tr>
                <td>
                  <div> <a @click="${viewImage}" data-images="${drow.images}">${drow.ten_hang}</a></div>
                  <div class="row">
                    <div>${Utils.num2Str(drow.don_gia)}</div> 
                    <div>x${Utils.num2Str(drow.so_luong)}</div>
                    <div>${Utils.num2Str(drow.thanh_tien)}</div> 
                  </div>
                </td>
              </tr>
            `)}
          </tbody>
        </table>
      </div>
    `)}
    
  </div>
</div>
`
    }
    ;
});